<template>
  <div class="container-fluid px-0" style="text-align: center">
    <div v-if="banner.length==1">
      <img class="banner_img_pc" :src='banner[0].fileUrl'/>
    </div>
    <div class="swiper mySwiper" v-else>
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in banner"
          :key="index"
        >
          <img class="banner_img_pc" :src="item.fileUrl" />
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>

   
  </div>
</template>

<script>
import { mapState } from "vuex";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
  computed: {
    ...mapState({
      // 映射 this.count 为 store.state.count
      projectConfig: (state) => state.config,
    }),
  },
  data() {
    return {
      language: sessionStorage.getItem("language") || "cn",
      isMobile: false,
      height: 510,
      projectId: "",
      banner:[]
    };
  },
  created() {
    this.projectId = sessionStorage.getItem("projectId");
    this.isMobile = this.$tool.isMobile();
  },
  async mounted() {
    await this.getBannerList();

    this.bannerFun();
  },
  methods: {
    async getBannerList() {
      let res = await this.$api.getBannerList({
        projectId: this.projectId,
        bannertype: this.isMobile ? "1" : "2",
        lang: this.language,
      });
      this.banner=res.data
    },
    bannerFun() {
      var swiper1 = new Swiper(".container-fluid .mySwiper", {
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".mySwiper .swiper-pagination",
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      });
    },
  },
};
</script>

<style scoped>
.swiper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
